import { render, staticRenderFns } from "./EditNote.vue?vue&type=template&id=650f98a4&scoped=true&"
import script from "./EditNote.vue?vue&type=script&lang=js&"
export * from "./EditNote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "650f98a4",
  null
  
)

export default component.exports